import script from "./ProductAbility.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductAbility.vue?vue&type=script&setup=true&lang=js"

import "./ProductAbility.vue?vue&type=style&index=0&id=1bbe4e3a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bbe4e3a"]])

export default __exports__